<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-5"><a href="#/The_Spirit_and_the_Skull2#Contents-A">Epigraph</a></p>
<p class="fp para-style-override-4"><span class="Italic char-style-override-2">Whoso neglects learning in his youth<br/>Loses the past and is dead for the future.</span></p>
<p class="body para-style-override-5">—Euripides</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// The_Spirit_and_the_Skull4.vue?66ab201c